import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import { selectGlobalOrgRegistrationsListItems } from "../../../../redux/global-org-registrations/selector";
import { globalOrgRegistrations } from "../../../../redux/global-org-registrations/action";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";



const GlobalOrgRegistryInfoComponent = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const globalOrgRegistrationsItems = useSelector(selectGlobalOrgRegistrationsListItems)
    const [storedItems, setStoredItems] = useState<any>({});

    useEffect(() => {
        const storedValue = localStorage.getItem('storageKey');
        if (storedValue) {
            try {
                const parsedValue = JSON.parse(storedValue);
                setStoredItems(parsedValue.items || []);
            } catch (error) {
                console.error("Error parsing JSON from localStorage:", error);
            }
        } else {
            console.log("No stored value found");
        }
    }, []);
console.log(storedItems?.DBNPId,'storedItems?.DBNPId')
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'DBNIEName', headerName: 'DBNIE Name'},
          { field: 'DBNPName', headerName: 'DBNP Name'},
          {field: 'DBNPRegistryName', headerName: 'DBNP Registry Name'},
          { field: 'AccountInfo.AccountName', headerName: 'Account Name',searchField: 'AccountName', filter: true,
            filterType: 'text'},
          { field: 'AccountInfo.Email', headerName: 'Email' ,searchField: 'email_id', filter: true,
            filterType: 'text'},
          { field: 'AccountInfo.Phone', headerName: 'Phone No',searchField: 'Phone', filter: true,
            filterType: 'text'},
          { field: 'OwnedByOUName', headerName: 'OwnedByOUName',searchField: 'OwnedByOUName', filter: true,
            filterType: 'text'},
            { field: 'Delivery_preference', headerName: 'Delivery Preference' },
            { field: 'CurrentlyServicing', headerName: 'Currently Servicing', cellRenderer: 'yesNoRenderer' },
            { field: 'IsAcceptOrderByDefaultEnabled', headerName: 'Accept Order By DefaultEnabled', cellRenderer: 'yesNoRenderer' },
            { field: 'IsDirectShipmentEnabled', headerName: 'Direct Shipment Enabled', cellRenderer: 'yesNoRenderer' },
            { field: 'UkId', headerName: 'UkId' },
            { field: 'UseSettingsFromConfigFile', headerName: 'Use Settings From ConfigFile', cellRenderer: 'yesNoRenderer' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
       
        ]);
      }

      const fetchGlobalOrgRegistrations=()=>{
        dispatch(globalOrgRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations/fetch`,entity:'globalOrgRegistrations',jsonData:{
        
      "Context": {},
      "Records": [
          {
          "DBNPId": storedItems?.DBNPId
          }
],
"Pagination":{
  "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",
}
          
        }}))
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
       navigate(`${data.GlobalOrgRegistryId}`)
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(globalOrgRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations/fetch`,entity:'globalOrgRegistrations',jsonData:{
      
         "Context": {},
      "Records": [
          {
          "DBNPId": storedItems?.DBNPId
          }
],
"Pagination":{
  "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",
            "searches": searchCriteria,
}
           
          }}))
      }
    
      const handleReloadData = () => {
        dispatch(globalOrgRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations/fetch`,entity:'globalOrgRegistrations',jsonData:{
          "Context": {},
          "Records": [
              {
              "DBNPId": storedItems?.DBNPId
              }
    ],
    "Pagination":{
      "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
    }
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];

	useEffect(() => {
    if(storedItems?.DBNPId)
    {
        createColumnDefs()
        fetchGlobalOrgRegistrations()
    }
	}, [pageData,pageSize,storedItems])

  const handleDelete=(data: any)=>{
    dispatch(globalOrgRegistrations.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations/delete`,
      entity: 'globalOrgRegistrations',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(globalOrgRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations/fetch`,entity:'globalOrgRegistrations',jsonData:{
  
      "Context": {},
      "Records": [
          {
          "DBNPId": storedItems?.DBNPId
          }
],
"Pagination":{
  "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",
}

    }}))
  });
  }
	return (
    <>
    {globalOrgRegistrationsItems?.isLoading ?  <PageLoader />: 
		<Table columnData={columnDefs} additionButtons={additionButtons}enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch}rowData={globalOrgRegistrationsItems?.result?.items} setPageData={setPageData}
    paginationData={globalOrgRegistrationsItems?.result?.pagination}
   setPageSize={setPageSize}headingName="Global Org Registrations"/>
     
  }
  </> 
	);
};

export default GlobalOrgRegistryInfoComponent;


